import { useSelector } from 'react-redux';

import Table from 'organisms/Table';
import { teamColumns, teamColumnsOrder } from 'util/constants';

export default function ProviderTeamDrawer() {
  const { groomers } = useSelector((state) => state.groomers);

  return (
    <div className="provider-team-drawer flex-column">
      <div className="w-100 flex-column">
        <h2 className="f28 mb-32">Team</h2>
        <div className="provider-team-drawer-table-container">
          <Table
            items={groomers}
            isLoading={false}
            onClickItem={() => {}}
            columns={teamColumns}
            columnsOrder={teamColumnsOrder}
          />
        </div>
      </div>
    </div>
  );
}
